module.exports = __webpack_public_path__ + "img/logoIned.73cf91fd.svg";